import { useSelectorNonNullable } from 'src/hooks/useSelector';
import { PriceChangeNotificationCartItem, PriceNotificationType } from 'src/models/price/priceCart';

const usePriceChangeNotificationCartItem = (): PriceChangeNotificationCartItem | undefined => {
    const cartNotifications = useSelectorNonNullable(({ priceCart }) => priceCart.notifications?.cart ?? []);
    return cartNotifications.find((cartNotification) =>
        [
            PriceNotificationType.PriceChangeSoon,
            PriceNotificationType.ProductCloseSoon,
            PriceNotificationType.ProductCloseSoonPriceChangeSoon,
        ].includes(cartNotification.type)
    ) as PriceChangeNotificationCartItem;
};

export default usePriceChangeNotificationCartItem;
